/* eslint-disable react-hooks/exhaustive-deps */
import { Container, Grid } from '@mui/material';
import moment from 'moment/moment';
import React, { useContext, useEffect, useState } from 'react'
import { Helmet } from 'react-helmet';
import { Link, useSearchParams, useNavigate } from 'react-router-dom';
import PageBreadcrumbs from '../../components/Common/Breadcrumbs';
import ExportToExcel from '../../components/Export/ExportToExcel';
import CircuitFilterModal from '../../components/Models/CircuitFilterModal';
import SortRecordsModal from '../../components/Models/SortRecordsModal';
import { useCircuitList, exportCircuits } from '../../hooks/circuit';
import { formatDateTime } from '../../utils/shortcuts';
import providerContext from '../../context/provider/providerContext';
import Alert from '../../components/Common/Alert';
import { useUser } from '../../hooks/user';
import { CIRCUIT_LIST_COLUMNS } from '../../config';
import { getLocal, setLocal } from '../../utils/localStorage';
import { isObjectEmpty } from '../../utils';
import CircuitFilterColumnsModal from '../../components/Models/CircuitFilterColumnsModal';
import { export_circuit_columns } from '../../utils/circuit_export';
import DocketRequestModal from '../../components/LCO/DocketRequestModal';
import CircuitCounter from '../../components/Counter/CircuitCounter';
// import MobileCircuits from '../../components/MobileTables/MobileCircuits';
import DocketCreateModal from '../../components/LCO/DocketCreateModal';
import CorporateDocketCreateModal from '../../components/LCO/CorporateDocketCreateModal';
import { useDebouncedCallback } from 'use-debounce';
import CircuitsTable from './Components/CircuitsTable';
import { toast } from 'react-toastify';

import { useCircuitStatics } from '../../hooks/circuit/statics';

export default function CircuitListPage() {
    const { user } = useUser();
    const { currentProvider } = useContext(providerContext);
    const navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams();
    const [enableApi, setAPI] = useState(false)
    const { circuitsData, circuitsIsLoading, handleParam } = useCircuitList('', enableApi);
    const { circuitStaticsData, handleStaticsParam } = useCircuitStatics(`?provider=${currentProvider?.id}`, enableApi)
    // console.log(circuitsData)

    const [circuitFilterModal, setCircuitFilterModal] = useState(false);
    const [circuitSortModal, setCircuitSortModal] = useState(false);
    const [docketRequestModal, setDocketRequestModal] = useState(false);
    const [corporateDocketModal, setCorporateDocketModal] = useState(false);
    const [docketRequestData, setDocketRequestData] = useState(null);
    const [exportData, setExportData] = useState([]);

    const [docketCreateModal, setCreateModal] = useState(false)
    const [currentData, setCurrentData] = useState(null)
    const [isExporting, setIsExporting] = useState(false)
    const [exportProgress, setExportProgress] = useState(0)
    const [exportCancelled, setExportCancelled] = useState(false)
    const [exportedCount, setExportedCount] = useState(0)
    const [exportReady, setExportReady] = useState(false)

    // Maximum safe limit for browser performance
    const MAX_SAFE_LIMIT = 100;

    const fetchData = useDebouncedCallback(() => {
        const currentParams = Object.fromEntries([...searchParams]);
        let params = ''
        // let limit = parseInt(currentParams?.limit ?? '20');
        let limit = parseInt(currentParams?.limit ?? '20') > MAX_SAFE_LIMIT ? MAX_SAFE_LIMIT : parseInt(currentParams?.limit ?? '20');
        let skip = parseInt(currentParams?.skip ?? '0');
        const provider = parseInt(currentProvider?.id);
        
        // Enforce maximum limit to prevent browser hangs
        if (limit > MAX_SAFE_LIMIT) {
            limit = MAX_SAFE_LIMIT;
            const updatedParams = {
                ...currentParams,
                limit: MAX_SAFE_LIMIT.toString()
            };
            setSearchParams(updatedParams);
            return;
        }
        
        if (currentParams.date_after) {
            params = new URLSearchParams({
                ...currentParams,
                date_after: moment(currentParams?.date_after).format('YYYY-MM-DD') ?? null,
                date_before: moment(currentParams?.date_before).format('YYYY-MM-DD') ?? null,
                limit,
                skip,
                provider
            }).toString();
        } else {
            params = new URLSearchParams({ ...currentParams, limit, skip, provider }).toString();
        }

        setAPI(true)
        params && handleParam(`?${params}`)
        handleStaticsParam(`?provider=${currentProvider?.id}`) // Get Statics
    }, 300)

    useEffect(() => {
        fetchData()

    }, [currentProvider, searchParams])


    //  Filter Data
    // Hide / Show Table Columns
    const [filterColumnsModal, setFilterColumnsModal] = useState(false)
    const [visibleCols, setVisibleCols] = useState(JSON.parse(getLocal(CIRCUIT_LIST_COLUMNS)) ?? {})
    useEffect(() => {
        const data = JSON.parse(getLocal(CIRCUIT_LIST_COLUMNS))
        if (!data || isObjectEmpty(data)) {
            setVisibleCols({
                circuit_type: false,
                provider: false,
                customer_id: false,
                customer_id_alt: false,
                customer_type: false,
                hirer: false,
                third_party_circuit_id: false,
                type_of_connectivity: false,
                office_name: false,

                territory_incharge: false,
                hub_incharge: false,
                fiber_vendor_team_leader: false,

                location_a: true,
                address_a: false,
                pin_a: false,
                mobile_a: false,

                location_b: true,
                mobile_b: false,
                pin_b: false,
                address_b: false,
                // area: false,
                address: false,

                bandwidth_mb_gig: false,

                // total_dockets: false,

                created_at: false,
                updated_at: true,
                status: true,
                actions: true,

                select_all: false,
            })
            setLocal(CIRCUIT_LIST_COLUMNS, JSON.stringify(visibleCols))
        }
    }, [])



    // Handle Export - Fetch all data in batches
    const handleExport = async () => {
        setIsExporting(true);
        setExportProgress(0);
        setExportCancelled(false);
        setExportedCount(0);
        setExportReady(false);
        
        try {
            const currentParams = Object.fromEntries([...searchParams]);
            const provider = parseInt(currentProvider?.id);
            const totalRecords = circuitsData?.counts?.total || 0;
            
            if (totalRecords === 0) {
                toast.warning('No records to export.');
                setIsExporting(false);
                return;
            }
            
            // Prepare base params
            let baseParams = {};
            if (currentParams.date_after) {
                baseParams = {
                    ...currentParams,
                    date_after: moment(currentParams?.date_after).format('YYYY-MM-DD') ?? null,
                    date_before: moment(currentParams?.date_before).format('YYYY-MM-DD') ?? null,
                    provider,
                };
            } else {
                const { limit, skip, ...exportParams } = currentParams;
                baseParams = { ...exportParams, provider };
            }
            
            // Fetch data in batches
            const BATCH_SIZE = 500;
            const totalBatches = Math.ceil(totalRecords / BATCH_SIZE);
            let allData = [];
            
            for (let i = 0; i < totalBatches; i++) {
                // Check if export was cancelled
                if (exportCancelled) {
                    toast.info('Export cancelled by user.');
                    setIsExporting(false);
                    setExportProgress(0);
                    setExportedCount(0);
                    setExportReady(false);
                    return;
                }
                
                const skip = i * BATCH_SIZE;
                const params = new URLSearchParams({
                    ...baseParams,
                    limit: BATCH_SIZE,
                    skip: skip
                }).toString();
                
                const batchResult = await exportCircuits(params);
                
                if (batchResult && batchResult.success && batchResult.data) {
                    allData = [...allData, ...batchResult.data];
                    
                    // Update progress and count
                    const progress = Math.min(100, Math.round(((i + 1) / totalBatches) * 100));
                    setExportProgress(progress);
                    setExportedCount(allData.length);
                } else {
                    toast.error(`Failed to fetch batch ${i + 1}. ${batchResult?.detail || ''}`);
                    break;
                }
            }
            
            if (allData.length > 0) {
                // Prepare export data with custom headings
                const exportResult = { success: true, data: allData };
                const customHeadings = export_circuit_columns(exportResult);
                setExportData(customHeadings);
                setExportReady(true);
                
                toast.success(`Successfully prepared ${allData.length} records for export!`);
            } else {
                toast.error('No data was exported. Please try again.');
                setIsExporting(false);
                setExportProgress(0);
                setExportedCount(0);
            }
        } catch (error) {
            console.error('Export error:', error);
            toast.error('Failed to export data. Please try again.');
            setIsExporting(false);
            setExportProgress(0);
            setExportedCount(0);
            setExportReady(false);
        }
    };

    // Handle Cancel Export
    const handleCancelExport = () => {
        setExportCancelled(true);
    };

    // Handle Download Complete
    const handleDownloadComplete = () => {
        setIsExporting(false);
        setExportProgress(0);
        setExportedCount(0);
        setExportReady(false);
        setExportData([]);
    };

    // Handle Reset Filters
    const handleResetFilters = () => {
        navigate('/circuit');
        toast.info('All filters have been reset');
    };

    // Check if any filters are applied
    const hasActiveFilters = () => {
        const currentParams = Object.fromEntries([...searchParams]);
        // Exclude pagination params from filter check
        const { limit, skip, ...filters } = currentParams;
        return Object.keys(filters).length > 0;
    };


    return (
        <>
            <Helmet>
                <title>Circuits - List</title>
            </Helmet>
            <PageBreadcrumbs
                title='All Circuits'
                alt='Circuits'
                RightComp={() =>
                    <div className='d-flex gap-1'>

                        {user?.permissions?.circuits?.add && <Link to='/circuit/add' className="btn btn-primary btn-style-light btn-sm"><i className="material-icons">add</i>Create</Link>}
                        {user?.permissions?.circuits?.view && <button className="btn btn-dark btn-style-light btn-sm" onClick={() => setCircuitFilterModal(true)}><i className="material-icons">filter_alt</i>Filter</button>}
                        {user?.permissions?.circuits?.view && <button className="btn btn-dark btn-style-light btn-sm" onClick={() => setCircuitSortModal(true)}><i className="material-icons">filter_list</i>Sort</button>}

                        {user?.permissions?.dockets?.view && !['UU'].some(role => user?.roles?.includes(role)) && <button className="btn btn-dark btn-style-light btn-sm" onClick={() => setFilterColumnsModal(true)}><i className="material-icons">segment</i>Visibility</button>}

                        {['EXP', 'EX'].some(role => user?.roles?.includes(role)) && (
                            <button 
                                className="btn btn-success btn-style-light btn-sm" 
                                onClick={handleExport}
                                disabled={isExporting || circuitsIsLoading}
                            >
                                <i className="material-icons">download</i>
                                {isExporting ? 'Exporting...' : 'Export'}
                            </button>
                        )}
                    </div>
                }
            />
            <Container maxWidth="xxl" disableGutters>
                {/* Export Progress Bar */}
                {isExporting && (
                    <div className="card border-0 shadow-sm mt-3">
                        <div className="card-body">
                            <div className="d-flex justify-content-between align-items-center mb-2">
                                <h6 className="mb-0">
                                    <i className="material-icons" style={{ fontSize: '20px', verticalAlign: 'middle' }}>
                                        {exportReady ? 'check_circle' : 'cloud_download'}
                                    </i>
                                    {' '}{exportReady ? `Export Ready: ${exportedCount} records` : `Exporting ${exportedCount} / ${circuitsData?.counts?.total} records...`}
                                </h6>
                                <div className="d-flex gap-2">
                                    {exportReady ? (
                                        <>
                                            <ExportToExcel 
                                                exportData={exportData} 
                                                isDisabled={false} 
                                                fileName={`Circuit Export - ${formatDateTime('today', 'DD-MM-YYYY')}`} 
                                            />
                                            <button 
                                                className="btn btn-sm btn-secondary" 
                                                onClick={handleDownloadComplete}
                                            >
                                                <i className="material-icons" style={{ fontSize: '16px', verticalAlign: 'middle' }}>close</i>
                                                {' '}Close
                                            </button>
                                        </>
                                    ) : (
                                        <button 
                                            className="btn btn-sm btn-danger" 
                                            onClick={handleCancelExport}
                                        >
                                            <i className="material-icons" style={{ fontSize: '16px', verticalAlign: 'middle' }}>cancel</i>
                                            {' '}Cancel
                                        </button>
                                    )}
                                </div>
                            </div>
                            <div className="progress" style={{ height: '25px' }}>
                                <div 
                                    className={`progress-bar progress-bar-striped ${!exportReady ? 'progress-bar-animated' : ''} bg-success`}
                                    role="progressbar" 
                                    style={{ width: `${exportProgress}%` }}
                                    aria-valuenow={exportProgress} 
                                    aria-valuemin="0" 
                                    aria-valuemax="100"
                                >
                                    {exportProgress}%
                                </div>
                            </div>
                            <small className="text-muted mt-1 d-block">
                                {exportReady ? 'Click "Download Now" to save the file.' : 'Preparing data for export...'}
                            </small>
                        </div>
                    </div>
                )}

                {user?.permissions?.circuits?.view && <CircuitCounter
                    searchParams={searchParams}
                    setSearchParams={setSearchParams}
                    // data={circuitsData?.counts}
                    data={circuitStaticsData?.counts}

                />}

                {/* Performance Info */}
                {circuitsData?.counts?.total > 1000 && (
                    <div className="alert alert-info alert-dismissible fade show mt-2" role="alert">
                        <strong>Performance Tip:</strong> Viewing {circuitsData?.counts?.total.toLocaleString()} total circuits. 
                        Use filters to narrow results for better performance. Maximum {MAX_SAFE_LIMIT} records per page.
                        <button type="button" className="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
                    </div>
                )}

                <Grid container>
                    <Grid item xs={12}>
                        {/* {circuitsIsLoading && <Loader />} */}

                        {circuitsData && !circuitsIsLoading && !circuitsData.success && <Alert
                            title='Warning!'
                            text={circuitsData.detail}
                            type='info'
                        />}

                        {/* No Records Found - Show Reset Filter Button */}
                        {circuitsData && !circuitsIsLoading && circuitsData.success && circuitsData.data?.length === 0 && (
                            <div className="card border-0 shadow-sm mt-3">
                                <div className="card-body text-center py-5">
                                    <i className="material-icons" style={{ fontSize: '64px', color: '#9e9e9e' }}>
                                        search_off
                                    </i>
                                    <h5 className="mt-3 mb-2">No Circuits Found</h5>
                                    <p className="text-muted mb-4">
                                        {hasActiveFilters() 
                                            ? 'No circuits match your current filters. Try adjusting or resetting them.'
                                            : 'No circuits are available at the moment.'}
                                    </p>
                                    {hasActiveFilters() && (
                                        <button 
                                            className="btn btn-primary btn-style-light"
                                            onClick={handleResetFilters}
                                        >
                                            <i className="material-icons me-1">filter_alt_off</i>
                                            Reset All Filters
                                        </button>
                                    )}
                                </div>
                            </div>
                        )}

                        {/* RENDER TABLE */}
                        <div className=''>
                            {/* {circuitsData && !circuitsIsLoading && circuitsData.success && renderTableType()} */}

                            {/* Show table when loading OR when data exists */}
                            {(circuitsIsLoading || (circuitsData && circuitsData.data?.length > 0)) && (
                                <CircuitsTable
                                    circuitsData={circuitsData}
                                    circuitsIsLoading={circuitsIsLoading}
                                    visibleCols={visibleCols}
                                    user={user}
                                    setDocketRequestData={setDocketRequestData}
                                    setDocketRequestModal={setDocketRequestModal}
                                    setCurrentData={setCurrentData}
                                    setCreateModal={setCreateModal}
                                    setCorporateDocketModal={setCorporateDocketModal}
                                    searchParams={searchParams}
                                    setSearchParams={setSearchParams}
                                />
                            )}
                        </div>

                    </Grid>

                    <CircuitFilterModal
                        modal={circuitFilterModal}
                        setModal={setCircuitFilterModal}
                        searchParams={searchParams}
                        setSearchParams={setSearchParams}
                    />
                    <CircuitFilterColumnsModal
                        modal={filterColumnsModal}
                        setModal={setFilterColumnsModal}
                        visibleCols={visibleCols}
                        setVisibleCols={setVisibleCols}
                    />
                    <SortRecordsModal
                        modal={circuitSortModal}
                        setModal={setCircuitSortModal}
                        searchParams={searchParams}
                        setSearchParams={setSearchParams}
                        redirect='/circuit'
                    />
                    <DocketRequestModal
                        modal={docketRequestModal}
                        setModal={setDocketRequestModal}
                        currentData={docketRequestData}
                        setCurrentData={setDocketRequestData}
                    />
                    <DocketCreateModal
                        modal={docketCreateModal}
                        setModal={setCreateModal}
                        currentData={currentData}
                        setCurrentData={setCurrentData}
                    />
                    <CorporateDocketCreateModal
                        modal={corporateDocketModal}
                        setModal={setCorporateDocketModal}
                        currentData={currentData}
                        setCurrentData={setCurrentData}
                    />
                </Grid>
            </Container>
        </>
    )
}
